import AdventureTeamPage from "./AdventureTeamPage";

export default AdventureTeamPage;
